export const DATA_TYPES = {
  expression: Symbol.for('expression'),
  diffExpression: Symbol.for('diffExpression'),
};
export const DATA_VALUES = {
  [DATA_TYPES.expression]: 'expression',
  [DATA_TYPES.diffExpression]: 'diffExpression',
};
